import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useMemo,
} from 'react';
import {
	defaultColDefination,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getSupplierSegmentation } from 'utils/apiRequests';
import { SettingsContext } from 'contexts/SettingsContext';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { getHeaderByTaxonomyType } from '../../CategoryManagement/utils';

const SupplierSegmentationContext = createContext();

export const SupplierSegmentationProvider = ({ children }) => {
	const { companyName } = useContext(SettingsContext);
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`${companyName}`);
	const [types, setTypes] = useState({});
	const [gridData, setGridData] = useState(initialGridData);
	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		segmentationUpdatedCount,
		isDirect,
		isSourceable,
		taxonomyType,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	const formatAnalysis = obj => {
		let result = [];
		for (let key in obj) {
			if (obj.hasOwnProperty(key) && key !== 'SELECT') {
				result.push(`${obj[key]} ${key}`);
			}
		}
		return result.join(', ');
	};

	const taxonomyHeader = useMemo(() => getHeaderByTaxonomyType(taxonomyType), [
		taxonomyType,
	]);

	const columnDefs = [
		{ headerName: 'Vendor Name', field: 'vendoR_NAME' },
		{ headerName: 'Is Prefered', field: 'is_Preferred', hide: true },
		{ headerName: `${taxonomyHeader} L1Category`, field: 'l1Category' },
		{ headerName: `${taxonomyHeader} L2Category`, field: 'l2Category' },
		{ headerName: `${taxonomyHeader} L3Category`, field: 'l3Category' },
		{ headerName: `${taxonomyHeader} L4Category`, field: 'l4Category' },
		{ headerName: 'Purchasing Group', field: 'purchasinG_GROUP' },
		{ headerName: 'Vendor Segmentation', field: 'vendor_Segmentation_Name' },
		{
			headerName: 'Vendor Contracts',
			field: 'vendor_Contract_Name',
			hide: true,
		},
	];

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						isSourceable: isSourceable,
						aptaxonomy: isDirect,
						taxonomyType: taxonomyType,
					};
					getSupplierSegmentation(payLoad)
						.then(response => {
							if (response.succeeded) {
								if (response.data.length > 0 || response.data !== null) {
									if (!!Object.keys(response.data).length) {
										if (response.data.explore.length > 0) {
											if (Object.values(response.data.keyValues).length > 0) {
												const analysisString = formatAnalysis(
													response.data.keyValues
												);
												setAnalysis(
													`${companyName} has ${analysisString} vendors`
												);
												setTypes(response.data.keyValues);
											} else {
												setAnalysis(`${companyName}`);
												setGridData(initialGridData);
											}
											const segmentationValues = Object.keys(
												response.data.keyValues
											).filter(el => el !== 'SELECT');
											const exploreFilteredResult = response.data.explore.filter(
												el =>
													segmentationValues.includes(
														el.vendor_Segmentation_Name
													)
											);
											setGridData(prevState => ({
												...prevState,
												rowData: exploreFilteredResult,
												columnDefs: columnDefs,
												defaultColDef: defaultColDefination,
											}));
										} else {
											setAnalysis(`${companyName}`);
										}
										setIsLoading(false);
									}
								} else {
									setIsLoading(false);
								}
							} else {
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			segmentationUpdatedCount,
			isDirect,
			isSourceable,
			taxonomyType,
		]
	);

	return (
		<SupplierSegmentationContext.Provider
			value={{ isLoading, analysis, gridData, types }}
		>
			{children}
		</SupplierSegmentationContext.Provider>
	);
};

export const useSupplierSegmentationContext = () => {
	return useContext(SupplierSegmentationContext);
};
